import * as THREE from 'three';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import SceneManager from '@/core/SceneManager.js';
import {GlobalManager} from '@/core/GlobalManager.js';
import CameraController from '@/core/CameraController.js';
import EventBus from '@/core/EventBus.js';
import GlobalConst from '@/core/GlobalConst.js'

/**
 * 该类是3D场景层，主要用于展示3D环境
 * 1、该类封闭一个场景类和一个透视相机
 * 2、resize操作需要回调该类的rize()方法
 */
export default class Map3DScene{
    
    enabled = true;
    
    i = 0;
    camera = null;
    scene = null;
    renderer = null;
    cameraController = null;

    constructor() {
        this.initScene();
        this.initCamera();
        this.addEvent();
    }

    initScene() {
        var intance = SceneManager.getInstance()
        this.scene = intance.createScene("Map3DScene",{ backgroundColor:0xffffff,
                                                        gridHelper:true,
                                                        arrow:true});
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        
        // 直射光源
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.scene.add(directionalLight);
    }

    initCamera() {
        this.camera = genPerspectiveCamera();
        this.renderer = GlobalManager.get("renderer");
        this.cameraController = new CameraController(this.camera, this.renderer.domElement);
        this.setCameraMode(GlobalConst.CAMERA_CONTROLE_MODE_ORBIT);
    }

    setCameraMode(mode){
        this.cameraController.switchMode(mode);
    }

    // 按照顺序改变相机控制器
    changeCameraContoller(){
        this.i++;
        if(this.i%4==0){
            this.setCameraMode(GlobalConst.CAMERA_CONTROLE_MODE_ORBIT);
        }else if(this.i%4==1){
            this.setCameraMode(GlobalConst.CAMERA_CONTROLE_MODE_FIRSTPERSON);
        }else if(this.i%4==2){
            this.setCameraMode(GlobalConst.CAMERA_CONTROLE_MODE_POINTERLOCK);
        }else if(this.i%4==3){
            this.setCameraMode(GlobalConst.CAMERA_CONTROLE_MODE_MAP);
        }
    }

    addEvent() {
        EventBus.on('resize', () => {
            var container = GlobalManager.get("gContainer");
            //解决屏幕切换回来时，相机的宽高比不会随窗口变化而变化
            if(!container){
              return ;
            }
  
            // 更新相机
            this.camera.aspect = container.clientWidth / container.clientHeight;
            this.camera.updateProjectionMatrix();
        });
    }

    animate(){
        
        if(!this.enabled){
            return ;
        }

        this.renderer.render(this.scene, this.camera);
        // 增加阻尼更新
        this.cameraController.update();
    }
}